import React from 'react';

type EvidenceExportPanelProps = {
  language?: 'en' | 'es';
  gatewayBaseUrl?: string;
  accessToken?: string | null;
};

const EvidenceExportPanel: React.FC<EvidenceExportPanelProps> = ({
  language = 'en',
  gatewayBaseUrl,
  accessToken,
}) => {
  const [error, setError] = React.useState<string | null>(null);
  const [busy, setBusy] = React.useState(false);
  const apiBase = String(gatewayBaseUrl || '').replace(/\/$/, '');

  const download = async () => {
    if (!apiBase || !accessToken) {
      setError(language === 'es' ? 'Se requiere inicio de sesión.' : 'Sign-in required.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const response = await fetch(`${apiBase}/api/v1/audits/evidence-export`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = 'nextcompli-evidence.zip';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Export failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="dashboard-settings-sections dashboard-settings-sections-centered" aria-label="Evidence export">
      <article className="card settings-card">
        <div className="settings-card-header">
          <h2>{language === 'es' ? 'Exportación de evidencia' : 'Evidence Export'}</h2>
        </div>
        <p className="dashboard-panel-subtitle">
          {language === 'es'
            ? 'Auditorías es el paquete de evidencia. Descarga un archivo con las listas de cumplimiento, los incidentes y el historial de cribado de esta cuenta. Es el archivo que guarda cuando alguien pregunta qué se hizo.'
            : 'Audits is the evidence pack. It downloads a file of the compliance checklists, the incidents, and the screening history for this account. Keep that file when someone asks what was done.'}
        </p>
        {error ? <p className="dashboard-form-error" role="alert">{error}</p> : null}
        <button type="button" className="dashboard-btn dashboard-btn-primary" disabled={busy} onClick={() => void download()}>
          {busy
            ? (language === 'es' ? 'Preparando…' : 'Preparing…')
            : (language === 'es' ? 'Descargar evidencia' : 'Download evidence pack')}
        </button>
      </article>
    </section>
  );
};

export default EvidenceExportPanel;
